import { Tab, Tabs } from '@mui/material'
import { Box } from 'components/elements'
import { IncidentArray } from 'configs/constants'
import { useState } from 'react'
interface IServiceTabsProps {
  primaryService?: number | undefined
  // Overrides the primary service's tab label where the portal presents that
  // service under a name of its own.
  primaryServiceLabel?: string
  activeServices?: number[]
  tabNumber?: number | null
  setTabNumber: (tab: number) => void
  children: React.ReactNode
}

export const ServiceTabs = ({ primaryService, primaryServiceLabel, activeServices, setTabNumber, children }: IServiceTabsProps) => {
  const [value, setValue] = useState(0)

  const handleChange = (event: React.SyntheticEvent, newValue: number) => {
    setValue(newValue)
  }

  // First Primary service Tab then Secondary Service tabs
  const sortedServices = primaryService ? [primaryService, ...(activeServices ?? [])] : [...(activeServices ?? [])]
  return (
    <>
      <Box css={{ borderBottom: 1, borderColor: 'divider' }}>
        <Tabs value={value} onChange={handleChange}>
          {sortedServices?.map(service => (
            <Tab
              key={service}
              label={service === primaryService && primaryServiceLabel ? primaryServiceLabel : service && IncidentArray[service - 1]}
              onClick={() => {
                setTabNumber(service as number)
              }}
            />
          ))}
        </Tabs>
        {children}
      </Box>
    </>
  )
}
